import React, { useState, useEffect } from 'react';

//componentes
import CabezoteComponent from '../../Components/Cabezote/cabezote.component'
import MisDatosContent from './MisDatosContent.component'
import MiCredito from './miCredito.component'
import MisPrestamos from './misPrestamos.component'
import PuntosVenta from './puntosVenta.component'
import MisPedidos from './misPedidos.component'
import * as constants from '../../global/const'
import Footer from '../../Components/Footer/Footer.components'
import axios from 'axios'
import PropTypes from 'prop-types';




//imagenes
import perfil from '../../assets/icons/perfil.svg'
import creditoA from '../../assets/icons/creditoA.svg';
import creditoB from '../../assets/icons/creditoB.svg';
import editFoto from '../../assets/icons/editFoto.svg';
import datos from '../../assets/icons/datos.svg';
import datosA from '../../assets/icons/datosA.svg';
import datosB from '../../assets/icons/datosB.svg';
import prestamoA from '../../assets/icons/prestamoA.svg';
import prestamoB from '../../assets/icons/prestamoB.svg';
import ubicacionB from '../../assets/icons/UbicacionB.svg';
import ubicacionA from '../../assets/icons/UbicacionA.svg';
import elementosA from '../../assets/icons/elementosA.svg';
import elementosB from '../../assets/icons/elementosB.svg';

import auth from '../../Helpers/auth'
import { MisCreditos } from './misCreditos.component';
import { log } from 'async';

import noIcon from '../../assets/icons/user-solid.svg' //imagen-DiapositivaIncompleta
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const MisDatos = (props) => {
    const [open, setOpen] = useState(false);
    const [close, setclose] = useState(true);
    const [mostrarOpciones, setMostrarOpciones] = useState(false);
    const [editable, setEditable] = useState(false);
    let history = useHistory();


    var Slider = {
        width: '70%',
        overflow: 'hidden',
        transition: 'all 0.5s',
    }

    var CloseSlider = {
        width: '70%',
        overflow: 'hidden',
        transition: 'all 0.5s',
    }

    var SliderMovil = {
        //height: '115vh',
        overflow: 'hidden',
        transition: 'all 0.5s',
    }

    var CloseSliderMovil = {
        height: 0,
        overflow: 'hidden',
        transition: 'all 0.5s',
    }
    const [content, setcontent] = useState(props.match.params.tipo);
    const userCurrent = JSON.parse(auth.getUsuario());
    const [urlImage, setUrlImg] = useState(constants.URL_BASE + 'ImageNit/' + userCurrent.urlFoto + '.png?');
    const [nombreNegocio, setNombreNegocio] = useState(userCurrent.nombreNegocio);
    const [errorV, setErrorV] = useState(null);
    const [validateImage, setValidateImage] = useState(false);

    const imageUpload = (e) => {
        setUrlImg(URL.createObjectURL(e.target.files[0]));
        const formData = new FormData()
        formData.append(
            'archivo',
            e.target.files[0]
        )

        axios.post(constants.EDITPHOTO + `?idClienteUsuario=${userCurrent.id}`, formData)
            .then((res) => {
                window.location.reload();
            }).catch((error) => {
                console.log(error.response.data.error);
                setErrorV(error.response.data.error);

            })
    };

    const updateName = (nameNegocio) => {
        axios.post(constants.EDITNAME + `?idClienteUsuario=${userCurrent.id}&nombreCliente=${nameNegocio}`)
            .then((res) => {
                let auxUsuario = userCurrent;
                auxUsuario.nombreNegocio = nameNegocio;
                auth.setUsuario(JSON.stringify(auxUsuario));
            }).catch((error) => {
                console.log(error);

            })
    }
    // useEffect(() => {
    //     function fileExists(file, cb) {
    //         urlImage.stat(file, (err, stats) => {
    //           if (err) {
    //             if (err.code === 'ENOENT') {
    //               return cb(null, false);
    //             } else { // en caso de otro error
    //               return cb(err);
    //             }
    //           }
    //           // devolvemos el resultado de `isFile`.
    //           return cb(null, stats.isFile());
    //         });
    //       }



    // }, []);

    const focus = () => {
        document.getElementById("label").focus()
    };

    useEffect(() => {
        focus();
    }, [editable]);

    return (
        <div className="home">
            <CabezoteComponent
                open={open}
                setOpen={setOpen}
                tipo={false}
                categoriasGlobal={null}
                close={close}
                setclose={setclose}
                mostrarOpciones={mostrarOpciones}
                setMostrarOpciones={setMostrarOpciones}
            />
            <div className="body_Datos">
                <div className="left">
                    <div className="top-Datos">
                        <div className="titulo">
                            <img src={perfil} alt="" />
                            <h5
                                onClick={() => history.push("/inicio")}
                            >
                                Inicio /
                                <span>
                                    Mi cuenta
                                </span>
                            </h5>
                        </div>
                        <div className="logo">
                            <div className="changePhoto">

                                {
                                    userCurrent.tipoClienteUsuario === 1 ?

                                        <button className="btnEdit">


                                            <div className="inputWrapper">


                                                <input className="fileInput" type="file" name="file1" onChange={imageUpload} />

                                            </div>


                                        </button> : null

                                }
                                {
                                    errorV ?
                                        <React.Fragment>
                                            <h1> <span>Error:</span> {errorV}</h1>
                                            <br /><br />
                                        </React.Fragment> : null
                                }
                                {

                                    <img className="logo-foto" src={constants.URL_BASE_IMAGES + "ImageNit/" + userCurrent.nit + ".png?" + Math.random()} alt="" onError={(e) => { e.target.onerror = null; e.target.src = noIcon }} />
                                }

                            </div>



                            <div className="edit" style={{ position: 'relative' }} >

                                <button className="btnChange" onClick={() => { setEditable("true"); focus() }} style={{ border: 'none', outline: 'none' }}>
                                    {
                                        userCurrent.tipoClienteUsuario === 1 ?
                                            <img src={editFoto} alt="" /> : null
                                    }
                                </button>


                                <label className="lbl" id="label" contentEditable={editable}> {nombreNegocio}</label>
                                {

                                    editable === "true" ?
                                        <button className="btn" onClick={() => {
                                            setEditable("false")
                                            setNombreNegocio(document.getElementById("label").innerText)
                                            updateName(document.getElementById("label").innerText);
                                        }}><i className="fas fa-check"></i></button> : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="body-left">
                        <ul onClick={() => { content === 'MisDatos' ? setcontent('MisDatos') : setcontent('MisDatos'); history.push({ pathname: '/MiPerfil/MisDatos' }) }} style={content === 'MisDatos' ? { background: 'rgba(244, 244, 244,10)' } : null}><img className="icono-Menu" src={content === 'MisDatos' ? datosA : datosB} alt="" /><label htmlFor="abrir-datos" className="color-label" style={content === 'MisDatos' ? { color: '#0075bb' } : null} > <b> Mis datos</b>  </label> <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img></ul>
                        <div className="rigth-movil" >
                            <div className="content" style={content === 'MisDatos' ? SliderMovil : CloseSliderMovil} >
                                {content === 'MisDatos' ?
                                    <MisDatosContent />
                                    : null
                                }
                            </div>
                        </div>
                        {userCurrent.tipoClienteUsuario === 1 ? <ul onClick={() => { content === 'MisPuntosVenta' ? setcontent('MisPuntosVenta') : setcontent('MisPuntosVenta'); history.push({ pathname: '/MiPerfil/MisPuntosVenta' }) }} style={content === 'MisPuntosVenta' ? { background: 'rgba(244, 244, 244,10)' } : null}> <img className="icono-Menu" src={content === 'MisPuntosVenta' ? ubicacionA : ubicacionB} alt="" /><label style={content === 'MisPuntosVenta' ? { color: '#0075bb' } : null} htmlFor="abrir-m" className="color-label"> <b>  Mis puntos de venta </b></label> <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img></ul> : null}
                        <div className="rigth-movil">
                            <div className="content">
                                {content === 'MisPuntosVenta' ?
                                    <PuntosVenta />
                                    : null
                                }
                            </div>
                        </div>
                        <ul onClick={() => { content === 'MisPedidos' ? setcontent('MisPedidos') : setcontent('MisPedidos'); history.push({ pathname: '/MiPerfil/MisPedidos' }) }} style={content === 'MisPedidos' ? { background: 'rgba(244, 244, 244,10)' } : null}> <img className="icono-Menu" src={content !== 'MisPedidos' ? elementosA : elementosB} alt="" /><label style={content === 'MisPedidos' ? { color: '#0075bb' } : null} htmlFor="abrir-elementos" className="color-label"> <b> Mis pedidos </b> </label>   <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img> </ul>
                        <div className="rigth-movil">
                            <div className="content">
                                {content === 'MisPedidos' ?
                                    <MisPedidos />
                                    : null
                                }
                            </div>
                        </div>
                        {/* <ul onClick={() => { content === 'MisPrestamos' ? setcontent('') : setcontent('MisPrestamos'); props.history.replace({ pathname: `./MiPerfil/MisPrestamos` }) }} style={content === 'MisPrestamos' ? { background: 'rgba(244, 244, 244,10)' } : null}><img className="icono-Menu" src={content === 'MisPrestamos' ? prestamoA : prestamoB} alt="" /><label style={content === 'MisPrestamos' ? { color: '#0075bb' } : null} htmlFor="abrir-creditos" className="color-label" > <b> Mis elementos en prestamo  </b> </label>    <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img>  </ul> */}
                        <div className="rigth-movil">
                            <div className="content">
                                {content === 'MisPrestamos' ?
                                    <MisPrestamos />
                                    : null
                                }
                            </div>
                        </div>
                        {/* {userCurrent.tipoClienteUsuario === 1 ? <ul onClick={() => { content === 'MiCredito' ? setcontent('') : setcontent('MiCredito'); props.history.replace({ pathname: `/MiPerfil/MiCredito` }) }} style={content === 'MiCredito' ? { background: 'rgba(244, 244, 244,10)' } : null}><img className="icono-Menu" src={content === 'MiCredito' ? creditoA : creditoB} alt="" /><label style={content === 'MiCredito' ? { color: '#0075bb' } : null} htmlFor="abrir-creditos" className="color-label" > <b> Mi Crédito  </b> </label> <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img></ul> : null} */}
                        {/* <div className="rigth-movil">
                            <div className="content">
                                {content === 'MiCredito' ?
                                    <MiCredito />
                                    : null
                                }
                            </div>
                        </div> */}

                        {/* {userCurrent.tipoClienteUsuario === 1 ? <ul onClick={() => { content === 'creditos' ? setcontent('') : setcontent('creditos') }} style={content === 'MiCredito' ? { background: 'rgba(244, 244, 244,10)' } : null}><img className="icono-Menu" src={content === 'MiCredito' ? creditoA : creditoB} alt="" /><label style={content === 'creditos' ? { color: '#0075bb' } : null} htmlFor="abrir-creditos" className="color-label" > <b> Solicitud Credito  </b> </label> <img src="/static/media/arrow2.a84bbc93.svg" className="circle-arrow" alt=""></img>
                        </ul> : null} */}
                        <div className="rigth-movil">
                            <div className="content">
                                {content === 'MiCredito' ?
                                    <MiCredito />
                                    : null
                                }
                            </div>
                        </div>

                    </div>

                </div>
                <div className="rigth" style={content !== '' ? Slider : CloseSlider}>
                    <div className="content">
                        {content === 'MisDatos' ?
                            <MisDatosContent />
                            : content === 'MisPuntosVenta' ?
                                <PuntosVenta />
                                : content === 'MisPedidos' ?
                                    <MisPedidos />
                                    : content === 'MiCredito' ?
                                        <MiCredito />
                                        : content === 'MisPrestamos' ?
                                            <MisPrestamos />
                                            : content === 'creditos' ?
                                                <div className="content-creditos"><MisCreditos /></div>
                                                : null
                        }

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}


export default MisDatos;